import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../reducers/userSlice';
import projectReducer from '../reducers/projectSlice';
import wellReducer from '../reducers/wellSlice';
import typeCurveReducer from '../reducers/typeCurveSlice';
import groupWellReducer from '../reducers/groupWellSlice';
import listReducer from '../reducers/listSlice';
import economicsReducer from '../reducers/economicsSlice';
import optionsReducer from '../reducers/optionsSlice';
import fbaReducer from '../reducers/fbaSlice';
import rtfoReducer from '../reducers/rtfoSlice';
import cdgrJobReducer from '../reducers/cdgrJobSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    projects: projectReducer,
    lists: listReducer,
    wells: wellReducer,
    typeCurves: typeCurveReducer,
    groupWells: groupWellReducer,
    economics: economicsReducer,
    options: optionsReducer,
    fba: fbaReducer,
    rtfo: rtfoReducer,
    cdgrJobs: cdgrJobReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }),
});
